import { EnquiryRequestService } from 'client/services';

const loader = async () => {
    const activityTypes = await EnquiryRequestService.getActivityTypes();
    return { activityTypes };
};

export default loader;
